// extracted by mini-css-extract-plugin
export var downArrow = "_82-0";
export var label = "_82-1";
export var treatmentCard = "_82-3";
export var upArrow = "_82-2";